module.exports = __webpack_public_path__ + "47c6db15340d09052dc4d2a5e5d97bf2.pdf";